import ExamImage from "../../components/ExamImage";
export default function MatchingWidgetStacked({
  blanks,
  options,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  const ROW_MIN_HEIGHT = 96;
  const IMAGE_HEIGHT = 140;

  const isReview = mode === "review";

  function setBlank(id, v) {
    if (mode !== "edit") return;
    onChange({ ...value, [id]: v.toUpperCase() });
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {/* ───────────── ANSWERS (TOP) ───────────── */}
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {blanks.map((b, i) => {
          const fb = feedback?.parts?.[b.id];

          const border =
            !isReview
              ? "2px solid #333"
              : fb?.correct
              ? "2px solid #2e7d32"
              : "2px solid #c62828";

          return (
            <div
              key={b.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                minHeight: 48
              }}
            >
              {/* NUMBER */}
              <strong style={{ width: 24, textAlign: "right" }}>
                {i + 1}.
              </strong>

              {/* INPUT */}
              <input
                type="text"
                maxLength={2}
                value={value[b.id] || ""}
                disabled={isReview}
                onChange={(e) => setBlank(b.id, e.target.value)}
                style={{
                  width: 48,
                  height: 40,
                  textAlign: "center",
                  fontSize: 16,
                  border,
                  borderRadius: 6
                }}
              />

              {/* LABEL */}
              <span style={{ fontSize: 15, fontWeight: 600 }}>
                {b.label}
              </span>

              {/* Optional expected answer */}
              {isReview && !fb?.correct && fb?.expected && (
                <span
                  style={{
                    marginLeft: 12,
                    fontSize: 12,
                    color: "#c62828"
                  }}
                >
                  (Correct: {fb.expected})
                </span>
              )}
            </div>
          );
        })}
      </div>

      {/* ───────────── EXAMPLES (BOTTOM) ───────────── */}
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {options.map((opt, i) => {
          const letter =
            opt.id ?? opt.value ?? String.fromCharCode(65 + i);

          return (
            <div
              key={letter}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                minHeight: ROW_MIN_HEIGHT
              }}
            >
              {/* LETTER */}
              <strong style={{ width: 32, fontSize: 32 }}>
                {letter}
              </strong>

              {/* MUSICAL EXAMPLE */}
              {opt.src ? (
                <ExamImage
                  src={opt.src}
                  alt={opt.alt || letter}
                  style={{
                    width: 700,
                    border: "1px solid #ccc",
                    borderRadius: 6
                  }}
                />
              ) : (
                <span style={{ fontSize: 14 }}>
                  {opt.label}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
